/*
<summary>
   This functional component is all about rendering the Import Tool BOM popup visibility wrapper.
   Developer: Aashish Singh, Created Date: 07-Sep-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import React, { useState } from 'react';

/**
* This function is used to wrap a component with import popup show/hide state and toggle handler.
* @param Component: Component to wrap with the popup visibility state
*/
const ImportToolBOMPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showImportToolBOMPopup, setShowImportToolBOMPopup] =
      useState<boolean>(false);

    const importToggleHandler = () => {
      setShowImportToolBOMPopup(!showImportToolBOMPopup);
    };

    return (
      <Component
        showImportToolBOMPopup={showImportToolBOMPopup}
        importToggleHandler={importToggleHandler}
        {...props}
      />
    );
  };

export default ImportToolBOMPopupHOC;
